<script>
  import QuestionnaireQuestionMixin from '../mixins/QuestionnaireQuestionMixin.vue'

  export default {
    name: 'rb-questionnaire-question-text',
    mixins: [ QuestionnaireQuestionMixin ]
  }
</script>
